import React from 'react';

import { IssuerQuotesTable } from '../IssuerQuotesTable/IssuerQuotesTable';

import classes from './issuerMyQuotes.module.scss';

export const IssuerMyQuotes = () => {
  return (
    <div className={classes.IssuerMyQuotes}>
      <div className={classes.IssuerMyQuotesContent}>
        <IssuerQuotesTable />
      </div>
    </div>
  );
};
